<template>
  <DynamicForm
    :data="registerForm"
    :formOptions="formOptions"
    @onSubmit="onSubmit"
    @onError="handleError"
  />
</template>
<script>
import DynamicForm from '@mints-components/cali-dynamic-form/App.vue';

export default {
  inject: ['$axios','locale'],
  components: { DynamicForm },
  props: {
    registerForm: { type: Object }
  },
  data() {
    return {
      status: {
        isLoading: false
      },
      formOptions: {
        displayTitle: false,
        displayDescription: true,
        displayAlerts: false
      }
    }
  },
  computed: {
    weekpassErrorMessage() {
      return locale === 'es' ? 'Parece que ya has solicitado una visita anteriormente…' : 'It seems you have already requested a visit before…';
    },
    goHomeButtonText() {
      return locale === 'es' ? 'Volver a la página de inicio' : 'Go back to home page';
    }
  },
  methods: {
    onSubmit(data) {
      // Send magic link to user after successfully submitting the form
      this.sendMagicLink(data.email);
    },
    sendMagicLink(contactEmail) {
      let redirectUrl = locale === 'es' ? '/es/visita-activacion' : '/en/visit-activation';
      let emailTemplate = locale === 'es' ? 'visit-magic-link-es' : 'visit-magic-link-en';
      let payload = {
        email: contactEmail,
        emailTemplate: emailTemplate,
        redirectUrl: redirectUrl
      }
      this.$axios.post(`/api/v1/login/send-magic-link`, {
        data: payload
      }).then((response)=>{
        // Redirect here
        window.location.href = `/${this.locale}/tp-visit`;
      }).catch(e => {
        this.displayErrorMessage();
      }).finally(() => {
        this.status.isLoading = false;
      });
    },
    handleError(data) {
      if (data && data.error === 'weekpass_error') {
        this.$swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: this.weekpassErrorMessage,
          footer: `<a href="/${locale}">${this.goHomeButtonText}</a>`
        })
      }
    }
  }
}
</script>
<style lang="scss">
.weekpass__container {
  display: flex;
  justify-content: center;
}
.weekpass_form {
  max-width: 700px;
}
</style>